import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles(() => ({
    root: {
        height: 40,
        '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: 8,
        },
    },
}));
//# sourceMappingURL=SearchField.styles.js.map